import Box from '@/design_system/Box';
import Button from '@/design_system/Button';
import { InputMultiSelect } from '@/design_system/InputMultiSelect/InputMultiSelect';
import Stack from '@/design_system/Stack';
import IconTrash from '@/icons/Trash.svg';
import { I18nWording } from '@/services/i18n';

import { LocaleInputs } from '../shared/LocaleInputs';

type AnswerRowInput = {
  text: I18nWording;
  defects?: { id: string }[];
};

type DefectTypeOption = {
  id: string;
  name: string;
};

export const AnswerRow = ({
  header,
  value,
  onUpdate,
  onDelete,
  deleteAriaLabel,
  textLabel,
  textPlaceholder,
  defectsLabel,
  defectsPlaceholder,
  defectTypeOptions,
  showErrors,
}: {
  header: React.ReactNode;
  value: AnswerRowInput;
  onUpdate: (updates: Partial<AnswerRowInput>) => void;
  onDelete: () => void;
  deleteAriaLabel: string;
  textLabel: string;
  textPlaceholder: string;
  defectsLabel: string;
  defectsPlaceholder: string;
  defectTypeOptions: DefectTypeOption[];
  showErrors: boolean;
}) => {
  return (
    <Box>
      <Stack gap="0.5rem">
        <Stack row alignItems="center" justifyContent="space-between">
          {header}
          <Button
            iconOnly
            variant="secondary-danger"
            size="small"
            onPress={onDelete}
            ariaLabel={deleteAriaLabel}
          >
            <IconTrash />
          </Button>
        </Stack>

        <LocaleInputs
          label={textLabel}
          placeholder={textPlaceholder}
          value={value.text}
          setValue={(text) => onUpdate({ text })}
          showErrors={showErrors}
        />

        <InputMultiSelect
          label={defectsLabel}
          options={defectTypeOptions}
          value={defectTypeOptions.filter((defectType) =>
            value.defects?.some((defect) => defect.id === defectType.id)
          )}
          getOptionValue={(opt) => opt.id}
          getOptionLabel={(opt) => opt.name}
          onChange={(selected) =>
            onUpdate({ defects: selected?.map((opt) => ({ id: opt.id })) ?? [] })
          }
          onRemoveValue={(removedKey) =>
            onUpdate({ defects: value.defects?.filter((defect) => defect.id !== removedKey) ?? [] })
          }
          placeholder={defectsPlaceholder}
        />
      </Stack>
    </Box>
  );
};
